// components/form/fields/TipTapField.tsx
import React, { useEffect } from "react";
import { useController, useFormContext } from "react-hook-form";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Image from "@tiptap/extension-image";
import DOMPurify from "dompurify";

interface TipTapFieldProps {
  name: string;
  label?: string;
  initialValue?: string; // optional HTML initial value
}

export const TipTapField: React.FC<TipTapFieldProps> = ({ name, label, initialValue = "" }) => {
  const { control, setValue } = useFormContext();

  const { field } = useController({ name, control });

  const editor = useEditor({
    extensions: [StarterKit, Image.configure({ allowBase64: true })],
    content: initialValue,
    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      // sanitize HTML
      const safeHtml = DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
      // store JSON representation in form
      setValue(name, editor.getJSON());
    },
  });

  useEffect(() => {
    if (editor && initialValue) {
      editor.commands.setContent(initialValue, false as any);
    }
  }, [editor, initialValue]);

  if (!editor) return null;

  return (
    <div className="space-y-2">
      {label && <label className="block font-medium">{label}</label>}
      <div className="border rounded-lg overflow-hidden">
        <EditorContent editor={editor} className="p-3 min-h-[200px]" />
      </div>
    </div>
  );
};